import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiTableHead, {
    TableHeadClassKey as MuiTableHeadClassKey,
    TableHeadBaseProps as MuiTableHeadBaseProps
} from "@material-ui/core/TableHead";


export type TableHeadClassKey = MuiTableHeadClassKey;
export type TableHeadBaseProps = MuiTableHeadBaseProps;

export interface TableHeadProps extends StandardProps<TableHeadBaseProps, TableHeadClassKey> {
    component?: React.ReactType<TableHeadBaseProps>;
}

class TableHead extends React.Component<TableHeadProps>{

    render() {
        const { ...props } = this.props;

        return <MuiTableHead {...props}>
            {this.props.children}
        </MuiTableHead>
    }
}

export default TableHead;
